export default __webpack_public_path__ + "static/bg-compare-light-4950c14141922cff3bda6677c2a95573.png";